<template>
  <el-form
    ref="tabForm"
    :model="tabItem"
    class="tab-item-form"
    :rules="rules"
    label-width="90px">
    <el-form-item
      label="导航名称:"
      prop="fieldName">
      <el-input v-model="tabItem.fieldName"></el-input>
    </el-form-item>
    <el-form-item
      label="H5显示:"
      prop="h5Display">
      <el-switch
        v-model="tabItem.h5Display"
        :active-value="1"
        :inactive-value="0"> </el-switch>
    </el-form-item>
    <el-form-item
      label="图文信息:"
      prop="fieldList">
      <desc-images
        v-model="tabItem.fieldList"
        :edit="true" />
    </el-form-item>
  </el-form>
</template>
<script>
import DescImages from '../../../components/public/desc-images.vue'
export default {
  name: 'TabItemForm',
  components: { DescImages },
  props: {
    vacIds: { type: Array, default() { return [] } }
  },
  data() {
    return {
      tabItem: { fieldName: '', fieldList: [], h5Display: 0 },
      rules: {
        fieldName: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入导航名称!'))
              } else if (value.length > 6) {
                callback(new Error('导航名称最多6个字符!'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        fieldList: [
          {
            validator: (rule, value, callback) => {
              if (value.length === 0) {
                callback(new Error('请上传图文!'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    init(options = {}) {
      this.tabItem = { ...this.tabItem, ...options }
    },
    validate(tab) {
      return new Promise((resolve, reject) => {
        this.$refs.tabForm.validate((valid) => {
          if (valid) {
            resolve(this.tabItem)
          } else {
            const rej = { tab }
            reject(rej)
          }
        })
      })
    }
  }
}
</script>
